import type { Immutable } from "immer";
import React from "react";
import { getGlobalSpacingClasses } from "tsi-common-react/src/components/_spacing/globalSpacing";
import { CAPTION_MEDIUM_CLASS_NAME } from "tsi-common-react/src/utils/typography";

import type { TestimonialBlock as TestimonialBlockValue } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { richHTML } from "../../utils/html";
import { StarRating } from "../StarRating";

import styles from "./index.module.scss";

export const TestimonialBlock = (
    block: Immutable<{ value: TestimonialBlockValue }>,
): React.JSX.Element => (
    <section
        className={concatClassNames([
            styles.testimonialBlock,
            getGlobalSpacingClasses(block.value.spacing),
        ])}
    >
        <div>
            <h3>{block.value.heading}</h3>
            <StarRating
                rating={block.value.testimonial?.stars}
                className={styles.testimonialStars}
                ratingClassName={styles.testimonialStarsRating}
                overlayClassName={styles.testimonialStarsOverlay}
                srLabel
            />
            <h4>{block.value.testimonial?.title}</h4>
            <div className={styles.testimonialMetadata}>
                <p className={CAPTION_MEDIUM_CLASS_NAME}>
                    by <strong>{block.value.testimonial?.author}</strong> in{" "}
                    {block.value.testimonial?.city},{" "}
                    {block.value.testimonial?.state}
                </p>
                <span className={CAPTION_MEDIUM_CLASS_NAME}>
                    {block.value.testimonial?.date}
                </span>
            </div>
            <div
                dangerouslySetInnerHTML={richHTML(
                    block.value.testimonial?.review,
                )}
            />
        </div>
    </section>
);
